import type { DisplayOrientation } from '../../../data/types';
import './OrientationIcon.css';

interface OrientationIconProps {
  orientation: DisplayOrientation;
  size?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

export function OrientationIcon({
  orientation,
  size = 14,
  color = 'currentColor',
  className = '',
  style,
}: OrientationIconProps) {
  const isPortrait = orientation === 'Portrait';
  const combinedClassName = `orientation-icon-svg ${className}`.trim();

  if (isPortrait) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={combinedClassName}
        style={style}
      >
        <rect
          x="3.25"
          y="1"
          width="9.5"
          height="14"
          rx="2"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="5.5"
          y1="12.5"
          x2="10.5"
          y2="12.5"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          opacity={0.6}
        />
      </svg>
    );
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={combinedClassName}
      style={style}
    >
      <rect
        x="1"
        y="3.25"
        width="14"
        height="9.5"
        rx="2"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="12.5"
        y1="5.5"
        x2="12.5"
        y2="10.5"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        opacity={0.6}
      />
    </svg>
  );
}
